import { apiClient, ApiName } from '@shared/services/api'

export const fetchDashboard = () => {
  return apiClient.get(ApiName.ADMINS, 'onboardings/dashboard')
}

export const fetchMarketStatus = () => {
  return apiClient.get(ApiName.CONFIGS, 'status/market')
}

export const fetchPTAX = (currency) => {
  return apiClient.get(ApiName.PTAXES, `${currency}/today`)
}
